import * as yup from 'yup';

const nullableNumber = (value: string, originalValue: string) =>
    originalValue.trim() === '' ? null : value;

const BasicDetailsSchema = {
    name: yup.string().required('FLEXCONTROLSFORMNAME'),
    type: yup.string().required('FLEXCONTROLSFORMTYPE'),
    processing_codes: yup
        .string()
        .nullable()
        .matches(/^[a-zA-Z0-9,-\s]*$/, 'not valid entry')
        .notRequired(),
    beneficiary_id: yup.string(),
    override_controls: yup
        .string()
        .matches(/^[a-zA-Z0-9,-\s]*$/, 'entry not valid'),
    currency_code: yup.string(),
    time_zone: yup.string(),
    max_limit: yup.number().when('type', {
        is: (value: string) =>
            value === 'usage_limit' || value === 'spending_limit',
        then: yup
            .number()
            .required('FLEXCONTROLSFORMMAXLIMIT')
            .typeError('FLEXCONTROLSFORMMAXLIMITNUM'),
        otherwise: yup
            .number()
            .nullable()
            .transform(nullableNumber)
            .typeError('FLEXCONTROLSFORMMAXLIMITNUM'),
    }),
    deny_code: yup.string().required('FLEXCONTROLSFORMDENYCODE'),
    active: yup.boolean(),
};

export default BasicDetailsSchema;
